import { GET_PLC_SAFETY_EVENTS, GET_PLC_SAFETY_EVENTS_SUCCESS, GET_PLC_SAFETY_EVENTS_ERROR } from './actionTypes';

export const getPlcSafetyEvents = (user) => ({
  type: GET_PLC_SAFETY_EVENTS,
  payload: { user },
});

export const getPlcSafetyEventsSuccess = (events) => ({
  type: GET_PLC_SAFETY_EVENTS_SUCCESS,
  payload: { events },
});

export const getPlcSafetyEventsError = (error) => ({
  type: GET_PLC_SAFETY_EVENTS_ERROR,
  payload: error,
});
